import {HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {catchError, Observable, tap, throwError} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {inject} from '@angular/core';

export function errorHandleInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const _snackBar = inject(MatSnackBar);
  return next(req).pipe(
    catchError((e) => {
      if(e?.status !== 401 ) {
        _snackBar.open(e?.error?.error, undefined, {
          horizontalPosition: "center",
          verticalPosition: "top",
          duration: 3000,
          panelClass: ['error-snackbar']
        });
      }
      return throwError(() => {
        return e;
      })
    })
  );
}
